var app = angular.module('leonardo');

var WidgetFolderFile = function(FolderFileService, FilterService, AuthDataService, $timeout, $http,
                                ngDialog, $state, NotificationService, FileService, AttachmentService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/folder-file.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      folder: '=',
      disableRequirement: '=',
      account: '=?'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.notice_options = FolderFileService.NOTICE_OPTIONS;
      scope.errorSize = false;

      scope.namePattern = {
        pattern: new RegExp('^[a-zA-Z0-9-_. ]*$'),
        text: 'Naming convention can be alphanumeric and might even include a "-", "_" or "."'
      };

      scope.isNull = isNull;

      scope.ngModelCtrl.$render = function() {
        scope.value = scope.ngModelCtrl.$modelValue;
        if (!isNull(scope.value)) {
          scope.value.notice_type = !isNull(scope.value.notice_type) ? scope.value.notice_type.toString() : scope.value.notice_type;
        }
      };

      scope.getSector = function() {
        if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
          return FilterService.hasFilter('sector') ? FilterService.getFilter('sector') : null;
        }
        return null;
      };

      scope.showDocManager = function() {
        scope.errorSize = false;
        ngDialog.openConfirm({
          template: 'views/templates/dialog/folder/selector.html',
          controller: 'FolderSelectorDialog',
          data: {
            sector: scope.getSector(),
            mode_folder: 'files',
            disable_folder: true,
            action: 'select',
            account: scope.account
          }
        }).then(function(file) {
          if (file){
            if (file.document_file) {
              $http.get(file.destiny.file, {responseType : 'blob'}).then(function(data){
                if (!scope.value.name) {
                  scope.value.name = file.destiny.name;
                }
                if (!isNull(file.destiny.expiration)) {
                  scope.value.expiration = file.destiny.expiration;
                }
                if (!isNull(file.destiny.notice_type)) {
                  scope.value.notice_type = file.destiny.notice_type.toString();
                }
                if (!isNull(file.destiny.notice)) {
                  scope.value.notice = file.destiny.notice;
                }
                if (!isNull(file.destiny.requirement)) {
                  scope.value.requirement = file.destiny.requirement;
                }
                scope.value.document_file = file.destiny.id;
                var filename = file.destiny.file.split('/');
                var f = new FileService([data.data], filename[filename.length - 1], {
                  type: data.data.type,
                  lastModified: moment()
                });
                scope.value.file = f;
              });
            }
            else {
              if (!scope.value.name) {
                scope.value.name = file.destiny.name;
              }
              if (!isNull(file.destiny.expiration)) {
                scope.value.expiration = file.destiny.expiration;
              }
              if (!isNull(file.destiny.notice_type)) {
                scope.value.notice_type = file.destiny.notice_type.toString();
              }
              if (!isNull(file.destiny.notice)) {
                scope.value.notice = file.destiny.notice;
              }
              if (!isNull(file.destiny.requirement)) {
                scope.value.requirement = file.destiny.requirement;
              }
              scope.value.document_folder = file.destiny.id;
              scope.value.link = $state.href('documents.list', {pk: file.destiny.id}, {absolute: true});
              scope.value.file = scope.value;
            }
          }
        }, function () {
          return;
        });
      };

      scope.onFileUpload = function(file) {
        if (!file) {
          return;
        }
        scope.errorSize = AttachmentService.checkErrorSize(file);
        if (scope.errorSize) {
          return;
        }
        scope.value.file = file;
      };

      scope.removeFile = function() {
        scope.errorSize = false;
        scope.value.file = null;
        scope.file = null;
      };

      scope.showDateNotice = function(){
        if (isNull(scope.value) || isNull(scope.value.expiration)) {
          return false;
        }
        return (scope.value.notice_type === FolderFileService.NOTICE_CUSTOM);
      };

      scope.updateNotice = function() {
        if (scope.value.expiration) {
          var expiration_date = moment(scope.value.expiration);
          if (scope.value && !isNull(scope.value.notice_type)) {
            switch (scope.value.notice_type.toString()) {
              case FolderFileService.NOTICE_DAY_BEFORE:
                scope.value.notice = expiration_date.subtract(1, 'days').format('YYYY-MM-DD');
                break;
              case FolderFileService.NOTICE_WEEK_BEFORE:
                scope.value.notice = expiration_date.subtract(7, 'days').format('YYYY-MM-DD');
                break;
              case FolderFileService.NOTICE_MONTH_BEFORE:
                scope.value.notice = expiration_date.subtract(1, 'months').format('YYYY-MM-DD');
                break;
              case FolderFileService.NOTICE_MONTHS_BEFORE:
                scope.value.notice = expiration_date.subtract(2, 'months').format('YYYY-MM-DD');
                break;
              case FolderFileService.NOTICE_CUSTOM:
                if (!scope.value.notice) {
                  scope.value.notice = undefined;
                }
                break;
            }
          }
        }
        else {
          scope.value.notice = undefined;
        }
        angular.element('body').addClass('block-ui-visible');
        angular.element('body').addClass('block-ui-active');
        scope.ngModelCtrl.$setViewValue(scope.value);
        $timeout(function() {
          angular.element('body').removeClass('block-ui-visible');
          angular.element('body').removeClass('block-ui-active');
        }, 500);
      };

      scope.$watch('value.expiration', function() {
        scope.ngModelCtrl.$setViewValue(scope.value);
        scope.updateNotice();
      });

      scope.$watch('value.notice_type', function() {
        scope.ngModelCtrl.$setViewValue(scope.value);
        scope.updateNotice();
      });

      scope.$watch('value.name', function() {
        scope.ngModelCtrl.$setViewValue(scope.value);
      });

      scope.$watch('value.file', function() {
        scope.ngModelCtrl.$setViewValue(scope.value);
      });

      scope.$watch('value.notice', function() {
        scope.ngModelCtrl.$setViewValue(scope.value);
      });

      scope.$watch('value.link', function() {
        scope.ngModelCtrl.$setViewValue(scope.value);
      });

      scope.$watch('value.requirement', function() {
        scope.ngModelCtrl.$setViewValue(scope.value);
      });
    }
  };
};

app.directive('widgetFolderFile', ['FolderFileService', 'FilterService', 'AuthDataService', '$timeout', '$http',
  'ngDialog', '$state', 'NotificationService', 'FileService', 'AttachmentService', WidgetFolderFile]);
